import React, { Fragment } from "react";
import Popup from "reactjs-popup";
class PopupModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = { open: false };
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.popupOnClose = this.popupOnClose.bind(this);
    }

    componentDidUpdate(nextProps) {
        const { isOpen } = this.props;
        if (nextProps.isOpen === isOpen || !isOpen) return;
        this.openModal();
    }

    openModal() {
        this.setState({ open: true });
    }

    closeModal() {
        this.setState({ open: false });
    }

    popupOnClose() {
        this.closeModal();
        this.props.closeFunction && this.props.closeFunction();
    }

    render() {
        const { model, hideButton } = this.props;
        const withIcon = this.props.withIcon ? this.props.withIcon : false;
        
        if (!model || !(model.title || model.content.value)) return null; 

        return (
            <>
                {!hideButton && (
                    <span className="modal__info-container">
                        {withIcon ? (
                            <>
                                <p className="checkout-info__summary-link modal__info-text">
                                    {model.infoText ? model.infoText : ""}
                                    {model.isPalletSplitCost ? model.palletSplitCostText : ""}
                                    <span onClick={this.openModal} className="checkout-info__summary-link modal__info-link-text">
                                        {model.buttonText ? model.buttonText : ""}
                                    </span>
                                </p>
                                <span className="modal__info-button"></span>
                            </>
                        ) : (
                            <>
                                <p className="checkout-info__summary-link modal__info-text">
                                    {model.infoText ? model.infoText : ""}
                                    {model.isPalletSplitCost ? model.palletSplitCostText : ""}
                                    {model.isPalletSplitCost && (
                                        <span onClick={this.openModal} className="checkout-info__summary-link modal__info-link-text">
                                            {model.buttonText ? model.buttonText : ""}
                                        </span>
                                    )}
                                </p>
                            </>
                            
                        )}
                    </span>
                )}
                <Popup
                    open={this.state.open}
                    closeOnDocumentClick
                    onClose={this.popupOnClose}
                >
                    <div className="modal__wrapper">
                        <a className="close" onClick={this.closeModal}>
                            &times;
                        </a>
                        <div className="modal">
                            <div className="content">
                                {model.title && (
                                    <h3 className="modal__header">
                                        {model.title}
                                    </h3>
                                )}
                                {model.content && (
                                    <div
                                        className="modal__text"
                                        dangerouslySetInnerHTML={{
                                            __html: model.content.value,
                                        }}
                                    ></div>
                                )}
                            </div>
                        </div>
                    </div>
                </Popup>
            </>
        );
    }
}

export default PopupModal;
